import { UserRoleNames } from '../models/AccessControl'
import { commonMenuItems, MenuItemProps } from './menuItemsConfig'

export const menuItems: Record<UserRoleNames, MenuItemProps[]> = {
  [UserRoleNames.Admin]: [
    commonMenuItems.find((item) => item.label === 'Home')!,
    commonMenuItems.find((item) => item.label === 'Clients')!,
    commonMenuItems.find((item) => item.label === 'Projects')!,
    commonMenuItems.find((item) => item.label === 'Favorites')!,
    commonMenuItems.find((item) => item.label === 'Drafts')!,
    commonMenuItems.find((item) => item.label === 'Archive')!,
  ],
  [UserRoleNames.LeadingArchitect]: [
    commonMenuItems.find((item) => item.label === 'Home')!,
    commonMenuItems.find((item) => item.label === 'Clients')!,
    commonMenuItems.find((item) => item.label === 'Projects')!,
    commonMenuItems.find((item) => item.label === 'Favorites')!,
    commonMenuItems.find((item) => item.label === 'Drafts')!,
    commonMenuItems.find((item) => item.label === 'Archive')!,
  ],
  [UserRoleNames.Architect]: [
    commonMenuItems.find((item) => item.label === 'Home')!,
    commonMenuItems.find((item) => item.label === 'Clients')!,
    commonMenuItems.find((item) => item.label === 'Projects')!,
    commonMenuItems.find((item) => item.label === 'Favorites')!,
    commonMenuItems.find((item) => item.label === 'Drafts')!,
    commonMenuItems.find((item) => item.label === 'Archive')!,
  ],
  [UserRoleNames.EngineeringAdmin]: [
    commonMenuItems.find((item) => item.label === 'Dashboard')!,
    commonMenuItems.find((item) => item.label === 'Projects & Requests')!,
    commonMenuItems.find((item) => item.label === 'Team')!,
    commonMenuItems.find((item) => item.label === 'Reports')!,
  ],
  [UserRoleNames.LeadingElectricalEngineer]: [
    commonMenuItems.find((item) => item.label === 'Dashboard')!,
    commonMenuItems.find((item) => item.label === 'Projects & Requests')!,
    commonMenuItems.find((item) => item.label === 'Team')!,
    commonMenuItems.find((item) => item.label === 'Reports')!,
  ],
  [UserRoleNames.ElectricalEngineer]: [
    commonMenuItems.find((item) => item.label === 'Dashboard')!,
    commonMenuItems.find((item) => item.label === 'Projects & Requests')!,
    commonMenuItems.find((item) => item.label === 'Team')!,
    commonMenuItems.find((item) => item.label === 'Reports')!,
  ],
  [UserRoleNames.LeadingStructuralEngineer]: [
    commonMenuItems.find((item) => item.label === 'Dashboard')!,
    commonMenuItems.find((item) => item.label === 'Projects & Requests')!,
    commonMenuItems.find((item) => item.label === 'Team')!,
    commonMenuItems.find((item) => item.label === 'Reports')!,
  ],
  [UserRoleNames.StructuralEngineer]: [
    commonMenuItems.find((item) => item.label === 'Dashboard')!,
    commonMenuItems.find((item) => item.label === 'Projects & Requests')!,
    commonMenuItems.find((item) => item.label === 'Team')!,
    commonMenuItems.find((item) => item.label === 'Reports')!,
  ],
  [UserRoleNames.Viewer]: [
    commonMenuItems.find((item) => item.label === 'Projects')!,
  ],
}
